import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import SearchIcon from '@material-ui/icons/Search';
import ClassIcon from '@material-ui/icons/Class';

import { fade } from '@material-ui/core/styles/colorManipulator';
import Editor from './Editor';
import Video from './Video'
import moment from 'moment'

import api from "../../../api/backend"

const styles = theme => ({
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class Course extends React.Component {
    state = {
        open: false, year: '', department: '', subjectId: '', instructor: [], title: '', numberOfMonth: 0, noOfStudents: 0, price: 0, description: ''
        , courses: [], tmpCourses: [], instructors: [], departments: [], loading: false
    };

    handleClickOpen = () => {
        this.getInstructor();
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    getDepartments = () => {
        api.getDepartments().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ departments: json })
            }
        }).catch(() => { })
    }

    getCourses = () => {
        this.setState({ loading: true })
        api.getAllCourses().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ courses: json, tmpCourses: json })
            }
        }).catch(() => { }).finally(() => {
            this.setState({ loading: false })
        })
    }

    createCourse = () => {
        const { year, department, subjectId, instructor, title, numberOfMonth, noOfStudents, price, description } = this.state;
        api.createCourse({ year, department, subjectId, instructor, title, numberOfMonth, noOfStudents, price, description }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.getCourses();
                this.setState({ open: false, title: '', description: '' })
            } else {
                console.error('ไม่สามารถสร้างคอร์สเรียนได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    };

    filterSubject = () => {
        const { department, departments } = this.state;
        if (department) {
            const found = departments.find((element) => {
                return element.id === department
            })

            if (found) {
                return found.subjects
            } else {
                return []
            }
        } else {
            return []
        }
    }

    getInstructor = () => {
        api.getInstructor().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ instructors: json })
            }
        }).catch(() => { })
    }

    find = () => {
        const { tmpCourses, term } = this.state
        if (term.length > 0) {
            this.setState({ courses: tmpCourses.filter((e) => { return e.course.title.includes(term) || e.course.description.includes(term) }) })
        } else {
            this.setState({ courses: tmpCourses })
        }
    }

    componentDidMount() {
        this.getDepartments();
        this.getCourses();
    }

    validate = () => {
        const { year, department, subjectId, instructor, title, numberOfMonth, description } = this.state;
        if (year && department && subjectId && instructor && numberOfMonth > 0 && title && title.length > 0 && description && description.length > 0) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { classes } = this.props;
        const { year, department, subjectId, instructor, title, numberOfMonth, noOfStudents, price, description, courses, instructors, departments, loading } = this.state;

        return (
            <div>
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            คอร์สเรียน
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.find()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <Button variant="contained" color="primary" fullWidth onClick={this.handleClickOpen}>
                                สร้างใหม่
                            </Button>
                        </Grid>
                    </Grid>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        fullWidth
                        maxWidth="md"
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">กลุ่มวิชา</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                สร้าง และแก้ไขคอร์สเรียน
                        </DialogContentText>
                            <Grid container spacing={24} style={{ paddingTop: 30 }}>
                                <Grid item xs={6}>
                                    <FormControl style={{ minWidth: 240 }} fullWidth>
                                        <InputLabel htmlFor="demo-controlled-open-select">ชื่อกลุ่มวิชา</InputLabel>
                                        <Select
                                            value={department}
                                            onChange={(event) => { this.setState({ department: event.target.value }) }}
                                            inputProps={{
                                                name: 'department',
                                                id: 'department-simple',
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>กรุณาเลือก</em>
                                            </MenuItem>
                                            {departments.map(department => (
                                                <MenuItem key={department.id} value={department.id}>{department.title}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl style={{ minWidth: 240 }} fullWidth>
                                        <InputLabel htmlFor="demo-controlled-open-select">ชื่อวิชา</InputLabel>
                                        <Select
                                            value={subjectId}
                                            onChange={(event) => { this.setState({ subjectId: event.target.value }) }}
                                            inputProps={{
                                                name: 'subject',
                                                id: 'subject-simple',
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>กรุณาเลือก</em>
                                            </MenuItem>
                                            {
                                                this.filterSubject().map(subject => (
                                                    <MenuItem key={subject.id} value={subject.id}>{subject.title}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl style={{ minWidth: 240 }} fullWidth>
                                        <InputLabel htmlFor="demo-controlled-open-select">ปีการศึกษา</InputLabel>
                                        <Select
                                            value={year}
                                            onChange={(event) => { this.setState({ year: event.target.value }) }}
                                            inputProps={{
                                                name: 'year',
                                                id: 'year-simple',
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>กรุณาเลือก</em>
                                            </MenuItem>
                                            <MenuItem value="2562">2562</MenuItem>
                                            <MenuItem value="2563">2563</MenuItem>
                                            <MenuItem value="2564">2564</MenuItem>
                                            <MenuItem value="2565">2565</MenuItem>
                                            <MenuItem value="2566">2566</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl style={{ minWidth: 240 }} fullWidth>
                                        <InputLabel htmlFor="demo-controlled-open-select">อาจารย์ผู้สอน</InputLabel>
                                        <Select
                                            value={instructor}
                                            onChange={(event) => { this.setState({ instructor: event.target.value }) }}
                                            inputProps={{
                                                name: 'instructor',
                                                id: 'instructor-simple',
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>กรุณาเลือก</em>
                                            </MenuItem>
                                            {instructors.map(instructor => (
                                                <MenuItem key={instructor.id} value={instructor.userName}>{instructor.firstName} {instructor.lastName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="title"
                                        name="title"
                                        label="ชื่อคอร์ส"
                                        fullWidth
                                        value={title}
                                        onChange={(event) => { this.setState({ title: event.target.value }) }}
                                    />
                                </Grid>
                                {/* <Grid item xs={6}>
                                    <TextField
                                        required
                                        id="startDate"
                                        name="startDate"
                                        label="วันที่เริ่มคอร์ส"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={startDate}
                                        onChange={(event) => { this.setState({ startDate: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        id="endDate"
                                        name="endDate"
                                        label="วันที่ปิดคอร์ส"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={endDate}
                                        onChange={(event) => { this.setState({ endDate: event.target.value }) }}
                                    />
                                </Grid> */}
                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="numberOfMonth"
                                        name="numberOfMonth"
                                        label="จำนวนเดือนที่สามารถเรียนได้"
                                        type="number"
                                        fullWidth
                                        value={numberOfMonth}
                                        onChange={(event) => { this.setState({ numberOfMonth: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="noOfStudents"
                                        name="noOfStudents"
                                        label="จำนวนนักเรียน"
                                        type="number"
                                        fullWidth
                                        value={noOfStudents}
                                        onChange={(event) => { this.setState({ noOfStudents: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="price"
                                        name="price"
                                        label="ราคา"
                                        type="number"
                                        fullWidth
                                        value={price}
                                        onChange={(event) => { this.setState({ price: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="description"
                                        name="description"
                                        label="รายละเอียด"
                                        fullWidth
                                        multiline
                                        rows={6}
                                        value={description}
                                        onChange={(event) => { this.setState({ description: event.target.value }) }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                ปิด
                        </Button>
                            <Button onClick={this.createCourse} color="primary" disabled={!this.validate()}>
                                สร้าง
                        </Button>
                        </DialogActions>
                    </Dialog>
                    <br /> <br />
                    {loading && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
                            <CircularProgress size={80} thickness={4} />
                            <Typography variant="title" color="textSecondary" style={{ marginTop: 24 }}>
                                กำลังโหลด...
                            </Typography>
                        </div>
                    )}
                    <Paper style={{ display: loading ? 'none' : 'block' }}>
                        <Table padding="dense">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ paddingLeft: 70 }}>ชื่อคอร์ส</TableCell>
                                    <TableCell>ชื่อวิชา</TableCell>
                                    <TableCell>ระดับชั้น</TableCell>
                                    <TableCell align="right" style={{ width: 100 }}>แก้ไขล่าสุด</TableCell>
                                    <TableCell align="right">สถานะ</TableCell>
                                    <TableCell align="right" style={{ width: 200 }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {courses.map(({ course, subject }) => (
                                    <TableRow key={course.id}>
                                        <TableCell component="th" scope="row">
                                            <IconButton aria-label="Class">
                                                <ClassIcon />
                                            </IconButton>
                                            {course.title}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {subject.title}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {subject.level}
                                        </TableCell>
                                        <TableCell align="right">{moment(course.modified).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="right">{course.deactivated ? <p style={{ color: 'red' }}>ไม่ใช้งาน</p> : ' ใช้งาน'}</TableCell>
                                        <TableCell align="right">
                                            <Video course={course} />
                                            <Editor course={course} subject={subject} onUpdateCompleted={this.getCourses}/>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </div>
        );
    }
}

Course.propTypes = {
};

export default withStyles(styles)(Course);